module.exports = __webpack_public_path__ + "static/media/29EUNOG6.24eefdea.jpg";